import React, { createRef } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import ErrorBoundary from "../../core/ErrorBoundary";
import Page from "../page/Page";
import NotFound from "../../core/NotFound";
import { paths } from "../../paths";
import { promiseTrackerHoc } from "react-promise-tracker";
import { AppContext } from "./AppContext";
import KeycloakProvider from "../KeycloakProvider";

const App = props => (
  <KeycloakProvider>
    <ErrorBoundary>
      <AppContext.Provider
        delay={300}
        value={{
          promiseInProgress: props.promiseInProgress,
          afInput: createRef(),
          logo: props.logo
        }}
      >
        <Router>
          <Switch>
            <Route path={paths.APPLICATION_PATH} component={Page} />
            <Route path="*" component={NotFound} />
          </Switch>
        </Router>
      </AppContext.Provider>
    </ErrorBoundary>
  </KeycloakProvider>
);

export default promiseTrackerHoc(App);
